<template>
  <div class="top">
    <div v-if="routePath=='/'">
    <span class="welcome" v-if="!user.token" @click="login"  style="margin-right: 40px;">欢迎登录！</span>
    <div class="weathers">{{city}}  {{todayWeathers.dayweather}}  {{todayWeathers.nighttemp}}° / {{todayWeathers.daytemp}}° <span style="position: relative;top: 2px;left: 6px;">﹀</span>
        <div class="threeDay">
          <div class="today">{{city}}  {{todayWeathers.daywind}}风  {{todayWeathers.daypower}}级</div>
          <div class="w-main">
            <div class="w-item">
              <div style="color:#999999;">今天</div>
              <div class="w-img"><img :src="'https://yjy.goodwebuy.cn/rmzd/weather_icon/'+todayWeathers.weatherIcon+'.png'" alt=""></div>
              <div>{{todayWeathers.nighttemp}}° / {{todayWeathers.daytemp}}°</div>
            </div>
            <div class="w-item">
              <div style="color:#999999;">明天</div>
              <div class="w-img"><img :src="'https://yjy.goodwebuy.cn/rmzd/weather_icon/'+tomorrowWeathers.weatherIcon+'.png'" alt=""></div>
              <div>{{tomorrowWeathers.nighttemp}}° / {{tomorrowWeathers.daytemp}}°</div>
            </div>
            <div class="w-item">
              <div style="color:#999999;">后天</div>
              <div class="w-img"><img :src="'https://yjy.goodwebuy.cn/rmzd/weather_icon/'+afterTomorrowWeathers.weatherIcon+'.png'" alt=""></div>
              <div>{{afterTomorrowWeathers.nighttemp}}° / {{afterTomorrowWeathers.daytemp}}°</div>
            </div>
          </div>
        </div>
    </div>
        <span class="welcome" v-if="user.token" >
    <!--      style="margin-left:-50px;"-->
    <!--      <img src="../../static/img/loading_null.png" style="width: 18px;position: relative;top: 3px;margin-right: 6px;">昵称名字-->
          <div style="margin-left:50px;">
            &nbsp;&nbsp;&nbsp;&nbsp;
          </div>
        </span>
        <ul v-if="!user.token">
          <!-- <li style="border-right: 1px solid #666666"><a style="color: #5aa8ff;" href="#" @click="login">请登录</a></li>
          <li class="appdown"><router-link style="color: #5aa8ff;" to="/appdown">下载客户端</router-link><img src="../assets/img/app.jpg" alt=""></li> -->
          <li><a href="#" @click="login">我的发布</a></li>
          <li><a href="#" @click="login">评论管理</a></li>
          <li><a href="#" @click="login">我的消息</a></li>
          <li><a href="#" @click="login">我的收藏</a></li>
          <li><a href="#" @click="login">我的赞</a></li>
          <li><a href="#" @click="login">阅读历史</a></li>
          <li><a href="/static/pcStatistics/index.html" target="_blank">平台统计</a></li>
          <li class="app-download app-download-bg">
            <div class="download-ewm">
              <div class="ewm-item">
                <div><img src="../assets/img/rmyd-app-android.png" alt=""></div>
                <div>人民优点</div>
              </div>
              <div class="ewm-item">
                <div><img src="https://cdn.rmzwds.com/rmzd/android.png" alt=""></div>
                <div>人民众点APP-android</div>
              </div>
              <div class="ewm-item">
                <div><img src="https://yjy.goodwebuy.cn/rmzd/assets/img/ios-app-download.jpeg" alt=""></div>
                <div>人民众点APP-ios</div>
              </div>
              <div class="ewm-item">
                <div><img src="https://yjy.goodwebuy.cn/rmzd/assets/img/tou-tiao-ewm.jpeg" alt=""></div>
                <div>人民众网头条号</div>
              </div>
              <div class="ewm-item" style="border-right: 0;">
                <div><img src="https://yjy.goodwebuy.cn/rmzd/assets/img/gong-zhong-ewm.jpeg" alt=""></div>
                <div>人民互联网电视公众号</div>
              </div>
            </div>
          </li>
        </ul>
        <ul v-else  @click="guangBoCloseNav">
<!--          <li class="appdown"><router-link style="color: #5aa8ff;" to="/appdown">下载客户端</router-link>-->
<!--            <img src="../assets/img/app.png" alt=""></li>-->
          <li>
            <router-link to="/mine">我的发布</router-link>
          </li>
          <li>
            <router-link to="/mine/comment">评论管理</router-link>
          </li>
          <li>
            <router-link to="/mine/tidings">我的消息</router-link>
          </li>
          <li>
            <router-link to="/mine/collection">我的收藏</router-link>
          </li>
          <li>
            <router-link to="/mine/praise">我的赞</router-link>
          </li>
          <li>
            <router-link to="/mine/readinglog">阅读历史</router-link>
          </li>
          <li><a href="/static/pcStatistics/index.html" target="_blank">平台统计</a></li>
          <li class="app-download app-download-bg">
            <div class="download-ewm">
              <div class="ewm-item">
                <div><img src="../assets/img/rmyd-app-android.png" alt=""></div>
                <div>人民优点</div>
              </div>
              <div class="ewm-item">
                <div><img src="https://cdn.rmzwds.com/rmzd/android.png" alt=""></div>
                <div>人民众点APP-android</div>
              </div>
              <div class="ewm-item">
                <div><img src="https://yjy.goodwebuy.cn/rmzd/assets/img/ios-app-download.jpeg" alt=""></div>
                <div>人民众点APP-ios</div>
              </div>
              <div class="ewm-item">
                <div><img src="https://yjy.goodwebuy.cn/rmzd/assets/img/tou-tiao-ewm.jpeg" alt=""></div>
                <div>人民众网头条号</div>
              </div>
              <div class="ewm-item" style="border-right: 0;">
                <div><img src="https://yjy.goodwebuy.cn/rmzd/assets/img/gong-zhong-ewm.jpeg" alt=""></div>
                <div>人民互联网电视公众号</div>
              </div>
            </div>
          </li>
          <li><a href="#" @click="signOut">退出</a></li>
        </ul>
        <PopupLogin v-show='user.loginFlag'></PopupLogin>
    </div>
    <!-- 二级页面的顶部显示一级导航 -->
    <div v-if="routePath!='/'">
      <div class="nav">
        <ul>
          <!-- <li @click="updateNav()"> <router-link active-class="active" to="/"  @click="goColumn"   exact>首页</router-link> </li> -->
          <li @click="updateNav()"> <a :href="webUrl+'/'" :class="routePath==='/'?'active':''"  @click="goColumn">首页</a> </li>
          <!-- <li v-for="(item,i) in navList" v-if="item.codeEn!=='recommend'"> -->
          <li v-for="(item,i) in navList" v-if="i<17">
            <a :href="webUrl+'\/'+item.codeEn+'?id='+item._id+'.html&title='+item.title" @click="goColumn" :data-title="item.title" :class="item.codeEn===navType?'active':''" v-if="item.codeEn!=='renmindianshang'">
              {{item.title}}
            </a>
            <a :href="webUrl+'\/infoPhantom'" rel="nofollow" target="_blank" v-else>{{item.title}}</a>
          </li>
<!--          <li>-->
<!--            <router-link to="/appDown">APP</router-link>-->
<!--          </li>-->
          <li v-if="navList.length>=18" @click="tagNavOthers" class="nav-jia">{{isShowNavOtherss==true?'×':'+'}}</li>
        </ul>
        <div class="nav-others-main" v-if="isShowNavOtherss">
          <ul class="nav-others">
            <li v-for="(item,i) in navList" v-if="i>=17">
              <a :href="webUrl+'\/'+item.codeEn+'?id='+item._id+'.html&title='+item.title" @click="goColumn" :data-title="item.title" :class="item.codeEn===navType?'active':''" :style="item.title.length>4?'width:0.46rem;':''"  v-if="item.codeEn!=='renmindianshang'">
                {{item.title}}
              </a>
              <a :href="webUrl+'\/infoPhantom'" rel="nofollow" target="_blank" v-else>{{item.title}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {newsNav,webUrl,getWeatherByIp} from '@/api'
  import PopupLogin from '@/components/PopupLogin.vue'
  import { mapState, mapActions } from 'vuex'

  export default {
    inject: ["eventHub"],
    name: 'Top',
    data() {
      return {
        webUrl:'',
        msg: 'Welcome to Your Vue.js App',
        // loginBtn: false
        navList: [],
        navType:'',
        isShowNavOtherss:false,
        routePath:'',
        city:'',
        todayWeathers:{},
        tomorrowWeathers:{},
        afterTomorrowWeathers:{}

      }
    },
    computed:{
      ...mapState([
        'user'
      ])
    },
    components: {
      PopupLogin
    },
    created() {
      this.routePath=this.$route.path;

      this.navType = window.location.pathname.replace('/','');
      if(this.routePath!='/'){
        newsNav().then(res => {
          if (!res.code) {
            // console.log(res.list);
            let arr=[];
              let tt='';
              for (var i = 0; i < res.list.length; i++) {
                  tt=res.list[i].title;
                  if(tt=='老区' || tt=='游戏' || tt=='电影' || tt=='智库' || tt=='动画' || tt=='中国制造'){
                     // console.log('频道'+tt);
                     continue;
                  }
                   arr.push(res.list[i]);
              }
              // console.log(arr);
            this.navList = arr;
            //setStore('nav', res.list)
          }
        })
      }

      this.eventHub.$on('on:title', (data) => {
        // console.log('Trigger this event and receive ' + data)
        // this.title=data
        if(data==''){this.routePath="/";this.navType='';}
      })


    },
    mounted(){
      this.getCityId();
      // 根据当前网络城市cip获取天气
        // getCIp().then(res => {
        //     // console.log('城市cip---'+res);
        //     let a=res.replace('var returnCitySN = ','');
        //     let b=a.replace(';','');
        //     let c=JSON.parse(b);
        //     this.city=c.cname;
        //     // console.log(c.cip);
        //     if(c.cip){

        //     }
        // })
        this.city=localStorage.getItem('cityname');
        let cityId=localStorage.getItem('cityid');
        let cityIp=localStorage.getItem('cityip');
        getWeatherByIp({ip:cityIp}).then(res => {
          if (res.code==0) {
            // console.log(res.info);
            res.info.map((item, index) => {
              if(item.dayweather){
                // 天气图片
                switch(item.dayweather) {
                  case '阴':
                     item['weatherIcon'] = 'yin';
                     break;
                  case '晴':
                     item['weatherIcon']='qing';
                     break;
                	case '多云':
                	   item['weatherIcon']='duoyun';
                	   break;
                	case '小雨':
                	   item['weatherIcon']='xiaoyu';
                	   break;
                	case '中雨':
                	   item['weatherIcon']='zhongyu';
                	   break;
                	case '大雨':
                	   item['weatherIcon']='dayu';
                	   break;
                	case '雷阵雨':
                	   item['weatherIcon']='leizhenyu';
                	   break;
                	case '雷阵雨并伴有冰雹':
                	   item['weatherIcon']='leiyubingbao';
                	   break;
                	case '暴雨':
                	   item['weatherIcon']='baoyu';
                	   break;
                	case '大暴雨':
                	   item['weatherIcon']='dabaoyu';
                	   break;
                	case '特大暴雨':
                	   item['weatherIcon']='tedabaoyu';
                	   break;
                	case '冻雨':
                	   item['weatherIcon']='dongyu';
                	   break;
                	case '小雪':
                	   item['weatherIcon']='xiaoxue';
                	   break;
                	case '中雪':
                		item['weatherIcon']='zhongxue';
                		break;
                	case '大雪':
                		item['weatherIcon']='daxue';
                		break;
                	case '暴雪':
                		item['weatherIcon']='baoxue';
                		break;
                	case '阵雪':
                		item['weatherIcon']='zhenxue';
                		break;
                	case '雨夹雪':
                		item['weatherIcon']='yujiaxue';
                		break;
                	case '霾':
                		item['weatherIcon']='mai';
                		break;
                	case '雾':
                		item['weatherIcon']='wu';
                		break;
                	case '浮尘':
                		item['weatherIcon']='fuchen';
                		break;
                	case '扬沙':
                		item['weatherIcon']='yangsha';
                		break;
                	case '沙尘暴':
                		item['weatherIcon']='shachenbao';
                		break;
                	case '强沙尘暴':
                		item['weatherIcon']='qiangshachenbao';
                		break;
                  default:
                    item['weatherIcon']='qing';
                }
                // 天气图片 end
              }
              return item
            });

            this.todayWeathers=res.info[0];
            this.tomorrowWeathers=res.info[1];
            this.afterTomorrowWeathers=res.info[2];

          }
        })

    },
    methods: {
      ...mapActions(['POPUP_LOGIN','USER_SIGNOUT']),
      login() {
        this.POPUP_LOGIN(true);
      },
      signOut() {
        this.USER_SIGNOUT();
        this.$router.push({name: 'Home'})
      },
      updateNav() {
        this.navType = window.location.pathname.replace('/','');
      },
      goColumn(e){
        let title=e.currentTarget.dataset.title;
        localStorage.setItem("title",!title?"":title)
        // this.title=e.currentTarget.dataset.title
        // this.eventHub.$emit('on:title', !title?"":title)
      },
      tagNavOthers(){
        this.isShowNavOtherss=!this.isShowNavOtherss;
      },
      getCityId(){
          // 获取城市信息cid,cname,cip等，，，在index.html通过script标签方式请求搜狐api获取
           var cid = returnCitySN["cid"];
           var cip = returnCitySN["cip"];
           var cname = returnCitySN["cname"];
           localStorage.setItem("cityid",cid);
           localStorage.setItem("cityip",cip);
           localStorage.setItem("cityname",cname);
       },
       guangBoCloseNav(){
         // console.log('广播，关闭导航下拉部分');
         this.eventHub.$emit('on:closeNav', 'closeNav');
       }

    }
  }
</script>

<style scoped>
  .top {
    width: 1118px;
    height: 46px;
    /*line-height: 54px;*/
    text-align: right;
    margin: 0 auto;
    font-size: 14px;
  }

  .top ul {
    float: right;
    margin-top: 12px;
  }

  .top ul li {
    display: block;
    float: left;
    padding-left: 10px;
    padding-right: 10px;
    /* line-height: 15px; */
  }

  .top ul li a {
    color: #666666;
  }
  .appdown{
    color: #5aa8ff !important;
    display: block !important;
    position: relative;
    height: 20px;
    overflow: hidden;
  }
  .appdown img{
    width: 80px;
    height: 80px;
    display: block;
    z-index: 1;
    position: absolute;
    left: 5px;
    top:30px;
    padding: 5px 5px 20px 5px;
    background-color: white;
  }
  .appdown:hover{
    overflow: visible;
  }
  .welcome{
    color: #569AFF;
    font-size:14px;
    line-height: 46px;
    float: left;
    cursor: pointer;
  }

  .nav {
    width: 100%;
    height: 100%;
    /* position: relative; */
    z-index: 1;
    margin: 0 auto;
  }
  .nav ul {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    padding: 0;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    /* flex-wrap: wrap; */
    flex-wrap: nowrap;
    -webkit-flex-wrap: nowrap;
    box-sizing: border-box;
    padding-top: 9px;
  }
  .nav ul li {
    /* width: 62px; */
    height: 28px;
    display: inline-block;
    border-radius: 20px;
    text-align: center;
    line-height: 28px;
    color: #2D2D2D;
    font-size: 14px;
    overflow: hidden;
    float: none;
  }
  .nav ul li.nav-jia{
    font-size: 20px;
    cursor: pointer;
  }
  .nav ul li a {
    display: block;
    color: #2D2D2D;
    width: 100%;
    height: 100%;
  }
  .nav ul li:hover{
    background-color: #dc2626;
    color: #ffffff !important;
  }
  .nav ul li:hover a {
    color: #ffffff !important;
  }
  .nav .nav-others-main{
    width: 100vw;
    height: 80px;
    background-color: #FAFBFC;
    position: absolute;
    top: 46px;
    left: 0;
    z-index: 99;
  }
  .nav .nav-others-main ul.nav-others{
    width: 1160px;
    height: 100%;
    box-sizing: border-box;
    padding-top: 11px;
    justify-content: left;
    -webkit-justify-content: left;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
  }
  .nav .nav-others-main ul.nav-others li a{
    width: 62px;
    height: 28px;
    display: inline-block;
    color: #333333;
    font-size: 14px;
  }
  .app-download{
    display: block;
    width: 19px;
    height: 21px;
    cursor: pointer;
  }
  .app-download-bg{
    background: url(https://yjy.goodwebuy.cn/rmzd/assets/img/app-download.png) no-repeat center;
    background-size: contain;
  }
  .app-download-bg:hover{
    background: url(https://yjy.goodwebuy.cn/rmzd/assets/img/app-download2.png) no-repeat center;
    background-size: contain;
  }
  .app-download-bg:hover .download-ewm{
    display: block;
    display: flex;
  }
  .download-ewm{
    width:880px;
    height:170px;
    background-color: #FFFFFF;
    box-shadow:0px 6px 18px 0px rgba(0, 0, 0, 0.18);
    color: #000000;
    position: relative;
    top: 22px;
    left: -850px;
    z-index: 10;
    display: flex;
    display: -webkit-flex;
    justify-content: space-around;
    -webkit-justify-content: space-around;
    align-items: center;
    display: none;
  }
  .download-ewm .ewm-item{
    flex: 1;
    -webkit-flex: 1;
    color: #333333;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    border-right: 1px solid #E6E6E6;
  }
  .download-ewm .ewm-item img{
    width:85px;
    height:85px;
    margin-bottom: 16px;
  }
  .weathers{
    color: #333333;
    font-size: 14px;
    line-height: 46px;
    cursor: pointer;
    float: left;
    position: relative;
  }
  .weathers:hover .threeDay{
    display: block;
  }
  .weathers .threeDay{
    width:260px;
    height:140px;
    line-height: 30px;
    font-size: 14px;
    color: #333333;
    background: #FFFFFF;
    box-shadow:0px 6px 18px 0px rgba(0, 0, 0, 0.18);
    position: absolute;
    left: 0;
    top: 46px;
    z-index: 10;
    display: none;
  }
  .weathers .threeDay .today{
    font-weight: bold;
    text-align: left;
    padding-left: 15px;
  }
  .weathers .threeDay .w-main{
    display: flex;
    justify-content: space-around;
    -webkit-justify-content: space-around;
    align-items: center;
    -webkit-align-items: center;
    text-align: center;
  }
  .weathers .threeDay .w-main .w-img img{
    width:33px;
    height:35px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Top.vue